// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resizer {
  width: 100%;
  height: 10px;
  background: #ccc;
  cursor: row-resize;
  position: absolute;
  top: 0;
  left: 0;
}

.elc-btn {
  border: 1px solid #d0d5dd;
  background-color: #fff;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.elc-btn:hover,
.elc-btn-single:hover {
  background-color: #e0edff;
  border: 1px solid #495cff;
  color: #495cff;
  transition: 0.3s;
}

.elc-delete-btn {
  border-radius: 0 5px 5px 0;
  border-left: 0;
}

.elc-nb-btn {
  border-radius: 5px 0 0 5px;
  border-right: 0;
}

.elc-btn-single {
  background-color: #0a56ae;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.elc-offcanvas-search {
  height: 30px;
  width: 150px;
  font-size: 12px;
}

.elc-offcanvas-select {
  height: 30px;
  width: 150px;
  border: 1px solid #d3d3d3;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 6px;
}

.next-action-button {
  background-color: #eff8ff;
  width: 100%;
  border: 2px solid #d9eeff;
  border-radius: 4px;
  padding: 4px 8px;
  color: #175cd3;
  cursor: pointer;
  text-align: center;
}

.next-action-button-disabled {
  background-color: #efeded;
  width: 100%;
  border: 2px solid #d3d3d3;
  border-radius: 4px;
  padding: 4px 8px;
  color: #909090;
  text-align: center;
}

.action-button {
  cursor: pointer;
}

.elc-offcanvas {
  background-color: #fff;
  padding-top: 15px;
}

@media (min-width: 1024px) {
  .elc-offcanvas-title {
    font-size: 12px;
  }

  .elc-btn,
.elc-btn-single {
    height: 30px;
    width: 30px;
  }

  .elc-offcanvas-select {
    height: 30px;
    width: 150px;
    border: 1px solid #d3d3d3;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 6px;
  }
}
@media (min-width: 1366px) {
  .elc-tile-title {
    font-size: 14px;
  }

  .elc-btn,
.elc-btn-single {
    height: 35px;
    width: 35px;
  }

  .elc-offcanvas-select {
    height: 35px;
    width: 150px;
    border: 1px solid #d3d3d3;
    font-size: 13px;
    display: flex;
    align-items: center;
    padding: 6px;
  }

  .elc-offcanvas-search {
    height: 35px;
    font-size: 13px;
    width: 200px;
  }
}
@media (min-width: 1920px) {
  .elc-tile-title {
    font-size: 14px;
  }

  .elc-offcanvas-select {
    height: 35px;
    width: 250px;
    border: 1px solid #d3d3d3;
    font-size: 13px;
    display: flex;
    align-items: center;
    padding: 6px;
  }

  .elc-offcanvas-search {
    height: 35px;
    width: 250px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./../dashboard/src/components/ELCTable/ELCTable.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AACF;;AAEA;EACE,yBAAA;EACA,sBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;;EAEE,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,0BAAA;EACA,cAAA;AAAF;;AAGA;EACE,0BAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,sBAAA;EACA,iBAAA;AAAF;;AAIA;EACE;IACE,eAAA;EADF;;EAIA;;IAEE,YAAA;IACA,WAAA;EADF;;EAIA;IACE,YAAA;IACA,YAAA;IACA,yBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,YAAA;EADF;AACF;AAIA;EACE;IACE,eAAA;EAFF;;EAKA;;IAEE,YAAA;IACA,WAAA;EAFF;;EAKA;IACE,YAAA;IACA,YAAA;IACA,yBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,YAAA;EAFF;;EAKA;IACE,YAAA;IACA,eAAA;IACA,YAAA;EAFF;AACF;AAKA;EACE;IACE,eAAA;EAHF;;EAMA;IACE,YAAA;IACA,YAAA;IACA,yBAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;IACA,YAAA;EAHF;;EAMA;IACE,YAAA;IACA,YAAA;IACA,eAAA;EAHF;AACF","sourcesContent":[".resizer {\n  width: 100%;\n  height: 10px;\n  background: #ccc;\n  cursor: row-resize;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.elc-btn {\n  border: 1px solid #d0d5dd;\n  background-color: #fff;\n  border-radius: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.elc-btn:hover,\n.elc-btn-single:hover {\n  background-color: #e0edff;\n  border: 1px solid #495cff;\n  color: #495cff;\n  transition: 0.3s;\n}\n\n.elc-delete-btn {\n  border-radius: 0 5px 5px 0;\n  border-left: 0;\n}\n\n.elc-nb-btn {\n  border-radius: 5px 0 0 5px;\n  border-right: 0;\n}\n\n.elc-btn-single {\n  background-color: #0a56ae;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.elc-offcanvas-search {\n  height: 30px;\n  width: 150px;\n  font-size: 12px;\n}\n\n.elc-offcanvas-select {\n  height: 30px;\n  width: 150px;\n  border: 1px solid #d3d3d3;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  padding: 6px;\n}\n\n.next-action-button {\n  background-color: #eff8ff;\n  width: 100%;\n  border: 2px solid #d9eeff;\n  border-radius: 4px;\n  padding: 4px 8px;\n  color: #175cd3;\n  cursor: pointer;\n  text-align: center;\n}\n\n.next-action-button-disabled {\n  background-color: #efeded;\n  width: 100%;\n  border: 2px solid #d3d3d3;\n  border-radius: 4px;\n  padding: 4px 8px;\n  color: #909090;\n  text-align: center;\n}\n\n.action-button {\n  cursor: pointer;\n}\n\n.elc-offcanvas {\n  background-color: #fff;\n  padding-top: 15px;\n}\n\n// Responsive\n@media (min-width: 1024px) {\n  .elc-offcanvas-title {\n    font-size: 12px;\n  }\n\n  .elc-btn,\n  .elc-btn-single {\n    height: 30px;\n    width: 30px;\n  }\n\n  .elc-offcanvas-select {\n    height: 30px;\n    width: 150px;\n    border: 1px solid #d3d3d3;\n    font-size: 11px;\n    display: flex;\n    align-items: center;\n    padding: 6px;\n  }\n}\n\n@media (min-width: 1366px) {\n  .elc-tile-title {\n    font-size: 14px;\n  }\n\n  .elc-btn,\n  .elc-btn-single {\n    height: 35px;\n    width: 35px;\n  }\n\n  .elc-offcanvas-select {\n    height: 35px;\n    width: 150px;\n    border: 1px solid #d3d3d3;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    padding: 6px;\n  }\n\n  .elc-offcanvas-search {\n    height: 35px;\n    font-size: 13px;\n    width: 200px;\n  }\n}\n\n@media (min-width: 1920px) {\n  .elc-tile-title {\n    font-size: 14px;\n  }\n\n  .elc-offcanvas-select {\n    height: 35px;\n    width: 250px;\n    border: 1px solid #d3d3d3;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    padding: 6px;\n  }\n\n  .elc-offcanvas-search {\n    height: 35px;\n    width: 250px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
